import PiDayGif from "@/assets/videos/pi_day_gif.gif"
import { appGrowthHackingSupplyWithdrawPopupState } from "@/atoms/appGrowthHackingState"
import { RelendModal } from "@/components/relendModal"
import useTrans from "@/hooks/useTrans"
import { AMPLITUDE_EVENT_MAP, BORROW, DEPOSIT, IS_MAINNET, REPAY, SUPPLY, WITHDRAW } from "@/utils/constants"
import { GrowthHackingTabType } from "@/utils/dataTypes"
import { sendEventLog } from "@/utils/tracking-events"
import { Box, Tab, Tabs, Typography } from "@mui/material"
import { useAtom } from "jotai"
import Image from "next/image"
import React, { useEffect, useState } from "react"
import * as styles from "./styles"

export const GrowthHackingSupplyWithdrawModal = () => {
  const trans = useTrans()
  const [popupState, setPopupState] = useAtom(appGrowthHackingSupplyWithdrawPopupState)
  const [tab, setTab] = useState<GrowthHackingTabType>()

  const { type, tokenName } = popupState
  useEffect(() => {
    if (type) {
      setTab(type === SUPPLY ? DEPOSIT : BORROW)
    }
  }, [type])
  const handleTabChange = (event: React.SyntheticEvent, newTab: GrowthHackingTabType) => {
    const eventName = AMPLITUDE_EVENT_MAP[newTab]
    if (eventName) {
      sendEventLog(eventName, {
        isMainnet: IS_MAINNET,
        token_name: tokenName,
      })
    }
    setTab(newTab)
  }

  const handleCloseModal = () => {
    setPopupState((prev) => ({
      ...prev,
      isOpen: false,
    }))
  }
  return (
    <>
      <RelendModal open={popupState.isOpen} handleClose={handleCloseModal}>
        {type === SUPPLY ? (
          <>
            <Tabs
              value={tab ?? DEPOSIT}
              onChange={handleTabChange}
              textColor='primary'
              indicatorColor='primary'
              aria-label='primary tabs example'
              sx={styles.textTab}
              variant='scrollable'
            >
              <Tab
                sx={styles.tabBorderTopLeft}
                data-testid={DEPOSIT}
                value={DEPOSIT}
                label={trans.dashboard.modal.supply}
              />
              <Tab
                sx={styles.tabBorderTopRight}
                data-testid={WITHDRAW}
                value={WITHDRAW}
                label={trans.dashboard.modal.withdraw}
              />
            </Tabs>
          </>
        ) : (
          <>
            <Tabs
              value={tab ?? BORROW}
              onChange={handleTabChange}
              textColor='primary'
              indicatorColor='primary'
              aria-label='primary tabs example'
              sx={styles.textTab}
              variant='scrollable'
            >
              <Tab
                sx={styles.tabBorderTopLeft}
                data-testid={BORROW}
                value={BORROW}
                label={trans.dashboard.modal.borrow}
              />
              <Tab
                sx={styles.tabBorderTopRight}
                data-testid={REPAY}
                value={REPAY}
                label={trans.dashboard.modal.repay}
              />
            </Tabs>
          </>
        )}
        <Box sx={styles.modalEmptyWrapper}>
          <Image src={PiDayGif} alt='hero-stat-icon' height={350} style={{ marginBottom: 16 }} />
          <Typography sx={styles.textStyle}>{trans.dashboard.modal.happy_pi_day}</Typography>
        </Box>
      </RelendModal>
    </>
  )
}
